module.exports = __webpack_public_path__ + "img/Img-404-01@2x.1ea4b8f2.png";